let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("cbkj0"), load("4Afgd"), load("9Oxgj"), load("l2LZP")]).then(() => parcelRequire('kMgpE'));